import { PlansSection, PropertyDataSection } from './components';

import './index.css';

interface TabsPropertyDataCivilProps {
  id: number;
  duplicateId?: number;
}

export const TabsPropertyDataCivil = ({
  id,
  duplicateId,
}: TabsPropertyDataCivilProps) => {
  return (
    <div className='mt-1'>
      <PlansSection id={id} duplicateId={duplicateId} />

      <PropertyDataSection id={id} duplicateId={duplicateId} />
    </div>
  );
};
